export default "/images/vendor/@coreui/icons/svg/flag/cif-sn.svg?ab47a67cab7715fc7db09b5b1685ae21";